import * as React from "react";
import Svg, { G, Circle, Path, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const SVGComponent = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <G filter="url(#filter0_d_5362_30795)">
      <Circle cx={20} cy={18} r={16} fill={props.bgColor || "white"} />
    </G>
    <Path
      d="M14 12L26 24"
      stroke={props.color || "#FF2E00"}
      strokeWidth={2.2}
      strokeLinecap="round"
    />
    <Path
      d="M26 12L14 24"
      stroke={props.color || "#FF2E00"}
      strokeWidth={2.2}
      strokeLinecap="round"
    />
    <Defs />
  </Svg>
);
export default SVGComponent;
